export function formatAmount(unitAmount: number, currency: string): string {
  try {
    return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(
      unitAmount / 100,
    );
  } catch {
    return `${(unitAmount / 100).toFixed(2)} ${currency}`;
  }
}
